import { Liff } from "@line/liff/dist/lib";

// LINE >= 15.12.0 resumes a closed LIFF app within 12 hours keeping the access
// token alive, but the ID token (valid 1 hour) is never reissued — so
// liff.isLoggedIn() can be true while liff.getIDToken() returns an expired token.
// Margin guards against the token expiring between this check and server verify.
const EXPIRY_MARGIN_MS = 5 * 60 * 1000;

export function isLineIdTokenUsable(liff: Liff): boolean {
  const idTokenEXP = liff.getDecodedIDToken()?.exp || 0;
  return Date.now() < idTokenEXP * 1000 - EXPIRY_MARGIN_MS;
}

// Returns true when the ID token is fresh enough to send to the API.
// Otherwise forces a re-login (page will redirect/reload) and returns false —
// callers must stop their flow when this returns false.
export async function ensureFreshLineTokens(liff: Liff): Promise<boolean> {
  if (isLineIdTokenUsable(liff)) return true;
  await liff.logout();
  if (liff.isInClient()) {
    // LIFF browser: liff.login() is not available, but liff.init() on reload
    // auto-logins and issues fresh tokens
    window.location.reload();
  } else {
    liff.login();
  }
  return false;
}
